import React, {Component} from "react";
import './baby-teething.css';
import * as teethActions from './TeethingActions';
import Jaw from './Jaw';

export default function Eruption({TeethEruptionData, eleRef}) {
    return(
        <div>
            <div className="tooth-erptn-inner">
                <Jaw TeethData={TeethEruptionData} eleRef={eleRef} section={"eruption"}/>
            </div>
            <div className="baby-size-weeks">
                <div className="weeks-section" onScroll={() => teethActions.monthbarScroll(eleRef)}>
                    <ul className="week-bar monthbar">
                        {eleRef.displayMonthslider()}
                    </ul>
                </div>
                <span className="week-next" data-icon-font="h" onClick={() => {eleRef.slideRight(eleRef.state.clickwedWeek)}}></span>
                <span className="week-prev" data-icon-font="g" onClick={() => {eleRef.slideLeft(eleRef.state.clickwedWeek)}}></span>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// src/shared/tools/baby-teething/Eruption.js